import React, { useContext, useEffect, useState } from "react";
import { getStockById } from "../../../../action";
import "./productdetaillist.css";
import { api } from "../../../../util/urlConfig";

export default function ProductDetailList({ product }) {
  const [productData, setProductData] = useState({});

  useEffect(() => {
    if (product) {
      getStockById(product.id, (res) => {
        setProductData(res.data);
      });
    }
  }, []);

  return (
    <>
      {productData !== "Can't find any stocks!" ? (
        <div className="product-detail">
          <img src={productData["product.upload_image.image_url"] ? api + "/" + productData["product.upload_image.image_url"] : "/img/dummy_avatar.png"} alt="product" />
          <div className="product-data">
            <p>
              Name : <span>{productData["product.name"]}</span>
            </p>
            <p>
              Category : <span>{productData["product.category.name"]}</span>
            </p>
            <p>
              Price : <span>Rs. {productData.unit_selling_price}.00</span>
            </p>
          </div>
        </div>
      ) : (
        <></>
      )}
    </>
  );
}
